export class Schedule {
  id: string;
  name: string;
  start: Date;
  end: Date;
  days: string[];
  type: "PRODUCTS" | "CATEGORIES";
  is_available: boolean;
  restaurant_id?: string;
  child_id?: string;

  menu_id?: string;
  item_ids?: string[];
  menu_ids?: string[];
  location_ids?: string[];
  category_ids?: string[];
  basic?: boolean;

  constructor(attr?: Partial<Schedule>) {
    if (attr) {
      Object.assign(this, attr);
    }
  }
}

export function mapSchedulesFromServer(schedulesFromServer: any[]): Schedule[] {
  if(schedulesFromServer) { 
    const mappedSchedules: Schedule[] = [];
    schedulesFromServer.forEach((schedule) => {
      if(schedule.type === "CATEGORIES") {
        mappedSchedules.push(new Schedule({id: schedule.id, name: schedule.name, start: schedule.start, end: schedule.end, days: schedule.days, type: schedule.type, is_available: schedule.is_available, restaurant_id: schedule.restaurant_id, child_id: schedule.category_schedule?.id, menu_id: schedule.category_schedule?.menu_id, category_ids: schedule.category_schedule?.category_ids, location_ids: schedule.category_schedule?.location_ids, basic: schedule.basic}));
      } else if(schedule.type === "PRODUCTS") {
        mappedSchedules.push(new Schedule({id: schedule.id, name: schedule.name, start: schedule.start, end: schedule.end, days: schedule.days, type: schedule.type, is_available: schedule.is_available, restaurant_id: schedule.restaurant_id, child_id: schedule.item_schedule?.id, item_ids: schedule.item_schedule?.item_ids, menu_ids: schedule.item_schedule?.menu_ids, location_ids: schedule.item_schedule?.location_ids, basic: schedule.basic}));
      }
    });
    return mappedSchedules;
  }
}
